module.exports = __webpack_public_path__ + "fonts/notosans-semibold-web.20a6cb8.woff";